module.exports = __webpack_public_path__ + "static/img/icon_cloud8.a8d9385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud8.jpg
// module id = j5bV
// module chunks = 21